import { render, staticRenderFns } from "./TrSelectGameWithTextImpr.vue?vue&type=template&id=7af211de&scoped=true&"
import script from "./TrSelectGameWithTextImpr.vue?vue&type=script&lang=js&"
export * from "./TrSelectGameWithTextImpr.vue?vue&type=script&lang=js&"
import style0 from "./TrSelectGameWithTextImpr.vue?vue&type=style&index=0&id=7af211de&lang=scss&scoped=true&"
import style1 from "./TrSelectGameWithTextImpr.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af211de",
  null
  
)

export default component.exports